import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../products-list/model/product-list.constants";
import { editProduct } from "./product-edit.component.service";
import ProductEditTemplateComponent from "./product-edit.template.component";
import { getProductInputs } from "../model/product.modal";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  PRODUCTS_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const ProductsEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let promoCodePayload = {};
    for (let i = 0; i < values.length; i++) {
      promoCodePayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const productResponse = await editProduct(
      location?.state?.row?.id,
      promoCodePayload
    );

    // INFO : check api response and show relevant alert message
    if (productResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: productResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getProductInputs({
      name: location?.state?.row?.name || "",
      image: location?.state?.row?.image || "",
      // description: location?.state?.row?.description || "",
      // price: location?.state?.row?.price || "",
      slug: location?.state?.row?.slug || "",
      // sort_order: location?.state?.row?.sort_order || "",
      status: location?.state?.row?.status || "",
      repeater: location?.state?.row?.repeater || "",
    }),
  };
  console.log(templateModal.formInputs);

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <ProductEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default ProductsEditComponent;
